import { createApp } from 'vue';
import RawToAvifConverter from '../Components/RawToAvifConverter.vue';

const root = document.getElementById('raw-to-avif-converter');
if (root) {
  createApp(RawToAvifConverter).mount('#raw-to-avif-converter');
}
